import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/shoes_log.svg'


const _hoisted_1 = { class: "logIn" }
const _hoisted_2 = { class: "logIn__iconClose" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logIn__imageContainer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "shoes-icon"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "logIn__title" }, "Log In to SneakersClub", -1)
const _hoisted_5 = { class: "logIn__error" }
const _hoisted_6 = { class: "logIn__inputContainer" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "logIn__error" }
const _hoisted_9 = { class: "logIn__btnContainer" }
const _hoisted_10 = {
  key: 0,
  class: "logIn__btn",
  type: "submit"
}
const _hoisted_11 = {
  key: 1,
  class: "logIn__btn"
}
const _hoisted_12 = { class: "logIn__para" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        class: "logIn__icon",
        name: "md-close-round",
        onClick: _ctx.closeModal,
        scale: "1.1"
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("form", {
      class: "logIng__cta",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
    }, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Email Address",
        autocomplete: "email",
        class: _normalizeClass(_ctx.emailError.length > 0 ? 'logIn__input logIn__input--active' : 'logIn__input'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
      }, null, 2), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.emailError), 1),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: _ctx.showPassword ? 'text' : 'password',
          autocomplete: "current-password",
          placeholder: "Password",
          class: _normalizeClass(
            _ctx.passwordError.length > 0
              ? 'logIn__input logIn__input--active logIn__input--margin'
              : 'logIn__input logIn__input--margin'
          ),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 10, _hoisted_7), [
          [_vModelDynamic, _ctx.password]
        ]),
        _createVNode(_component_v_icon, {
          onClick: _ctx.toggleShowPassword,
          class: "logIn__inputICon",
          fill: "hsl(219, 9%, 45%)",
          scale: "1.1",
          name: _ctx.showPassword ? 'bi-eye' : 'bi-eye-slash'
        }, null, 8, ["onClick", "name"])
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.passwordError), 1),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.isFetching)
          ? (_openBlock(), _createElementBlock("button", _hoisted_10, "Log In"))
          : _createCommentVNode("", true),
        (_ctx.isFetching)
          ? (_openBlock(), _createElementBlock("button", _hoisted_11, [
              (_ctx.isFetching)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    name: "fa-spinner",
                    fill: "white",
                    animation: "spin-pulse"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_12, [
        _createTextVNode(" Don't have an account? "),
        _createElementVNode("button", {
          type: "button",
          class: "logIn__accountBtn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeView('SignUp')))
        }, "Register")
      ])
    ], 32)
  ]))
}